// src/pages/EmbedContactForm.js
import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ContactFormSection from '../components/ContactFormSection';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#ff8c00',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const EmbedContactForm = () => {
  // Get source from URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source') || 'wordpress-column';
  
  // Send height to parent for auto-resize
  useEffect(() => {
    const sendHeight = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage(
        { type: 'resize', height: height },
        '*' // In production, replace with your WordPress domain
      );
    };

    // Send initial height
    sendHeight();
    
    // Send height on window resize
    window.addEventListener('resize', sendHeight);
    
    // Observer for content changes
    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true
    });

    return () => {
      window.removeEventListener('resize', sendHeight);
      observer.disconnect();
    };
  }, []);
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ 
        backgroundColor: 'transparent',
        padding: 0,
        margin: 0
      }}>
        <ContactFormSection 
          source={source}
          title="立即免費預約專人諮詢"
          subtitle="請留下資訊，我們將有專業顧問於 2 天工作天內與您聯繫！"
          backgroundColor="transparent"
          containerMaxWidth="md"
        />
      </div>
    </ThemeProvider>
  );
};

export default EmbedContactForm;